var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.$route.meta.guest)?_c('NavHeader'):_vm._e(),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{staticClass:"router-view-container",class:{ 'has-nav': !_vm.$route.meta.guest }},[_c('router-view')],1)]),(!_vm.$route.meta.guest)?_c('NavFooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }